import { Link } from 'react-router-dom';
import type { Character } from '@/mocks/characters';

interface CharacterCardProps {
  character: Character;
}

export default function CharacterCard({ character }: CharacterCardProps) {
  return (
    <div className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300">
      <div className="relative h-72 overflow-hidden">
        <img
          src={character.image}
          alt={`亲吻姐姐 - ${character.name}`}
          title={`亲吻姐姐角色 - ${character.name}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <h3 className="text-white text-lg font-heading font-bold">{character.name}</h3>
          <p className="text-white/80 text-xs font-body mt-0.5">{character.nameJa}</p>
        </div>
      </div>
      <div className="p-4">
        <p className="text-xs font-body text-secondary-600 font-medium mb-3">
          <span className="w-4 h-4 inline-flex items-center justify-center mr-1">
            <i className="ri-mic-line text-xs"></i>
          </span>
          CV: {character.voiceActor}
        </p>
        <p className="text-sm text-foreground-600 font-body line-clamp-2 leading-relaxed">{character.description}</p>
        <div className="flex flex-wrap gap-1.5 mt-3">
          {character.traits.map((trait) => (
            <span key={trait} className="px-2 py-0.5 text-xs font-body rounded-full bg-secondary-100 text-secondary-700">
              {trait}
            </span>
          ))}
        </div>
        <Link
          to={`/article/${character.slug === 'ako' ? 'ako-character-deep-dive' : character.slug === 'riko' ? 'riko-character-guide' : 'keita-character-analysis'}`}
          className="mt-4 inline-flex items-center gap-1 text-sm font-body text-primary-500 hover:text-primary-600 transition-colors"
        >
          查看详情
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs"></i>
          </span>
        </Link>
      </div>
    </div>
  );
}